import { IntegratorMovementFilter } from "./integrator-movement-types";

export const initializeFilter = (): IntegratorMovementFilter => ({
  id: null,
  financialGroup: null,
  contractId: null,
  subContractId: null,
  name: null,
  insuredDocumentNumber: null,
  movementIntegradoraType: [],
  origin: [],
  status: [],
  carrierIds: [],
  createdDateStart: null,
  createdDateEnd: null,
  page: 1,
  size: 25,
  sort: "id,desc",
});
